import { createFileRoute } from "@tanstack/react-router";

import { OrderList as OrderMain } from "@/features/office/orders/list";
import { orderListSearchSchema } from "@/features/office/orders/list/_configs/order-list-search-schema";

export const Route = createFileRoute("/office/orders/all")({
  validateSearch: orderListSearchSchema,
  component: () => <OrderMain />,
});
